import { AsyncPipe, NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding, inject } from '@angular/core';

import { MarqueeTile } from '@frontend/sports/types/components/content';
import { MarqueePayload } from '@frontend/sports/types/components/widget/types';
import { WidgetSkeletonData, WidgetSkeletonModel } from '@frontend/sports/widget/core/feature';
import { Observable, combineLatest, startWith } from 'rxjs';

import { MarqueeResponseMapperService } from './marquee-response-mapper.service';
import { MarqueeWidgetDataService } from './marquee-widget-data.service';

@Component({
    selector: 'ms-marquee-widget-skeleton',
    template: `
        @if (data$ | async; as data) {
            @if (data.showSkeleton) {
                @if (data.tiles[0]; as tile) {
                    @if (tile.imageUrl; as img) {
                        <div class="marquee-card marquee-card-with-img">
                            <img class="marquee-background-image" priority ngSrcset="1x, 2x, 3x" [width]="280" [height]="140" [ngSrc]="img" />
                        </div>
                    } @else {
                        <div class="marquee-card marquee-card-without-img"></div>
                    }
                }
            }
        }
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [AsyncPipe, NgOptimizedImage],
})
export class MarqueeWidgetSkeletonComponent implements WidgetSkeletonModel {
    private readonly marqueeDataService = inject(MarqueeWidgetDataService);
    readonly data = inject(WidgetSkeletonData<MarqueePayload>);
    private readonly responseMapper = inject(MarqueeResponseMapperService);
    private mappedTiles = this.responseMapper.mapFixtures(this.data.widget.payload?.fixtures, this.data.widget.payload?.tiles);

    readonly showSkeleton$ = this.data.widgetsBeforeLoaded$;

    readonly data$ = combineLatest({
        tiles: (
            this.marqueeDataService.combineWithPromotions(this.data.widget.payload, this.mappedTiles) as unknown as Observable<MarqueeTile[]>
        ).pipe(startWith(this.mappedTiles)),
        showSkeleton: this.showSkeleton$,
    });

    @HostBinding('class')
    get widgetClass(): string {
        return `widget-skeleton--marquee`;
    }
}
